import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { CONFIG } from '../../core/config';
import { EquipmentFunctionModelSelectionCriteriaBase } from '../../viewmodels/equipment/equipment-function-model-selection-criteria-base';
import { IIsoHierarchyDataSelectionLoadService } from './iso-hierarchy-data-selection-load-service';

@Injectable({
  providedIn: 'root',
})
export abstract class IsoHierarchyQueryBaseService implements IIsoHierarchyDataSelectionLoadService {
  selectionCriteriaChanged: Subject<EquipmentFunctionModelSelectionCriteriaBase> = new Subject<EquipmentFunctionModelSelectionCriteriaBase>();
  invalidCriteriaSelected: Subject<any> = new Subject<any>();
  recreateCriteriaRequested: Subject<any> = new Subject<any>();
  excludedDataIds: string[] = [];

  selectData(criteria: EquipmentFunctionModelSelectionCriteriaBase) {
    throw new Error('Method not implemented.');
  }

  createCriteria(): EquipmentFunctionModelSelectionCriteriaBase {
    throw new Error('Method not implemented.');
  }

  findData(criteria: EquipmentFunctionModelSelectionCriteriaBase): Observable<EquipmentFunctionModelSelectionCriteriaBase> {
    throw new Error('Method not implemented.');
  }

  validateCriteria(criteria: EquipmentFunctionModelSelectionCriteriaBase): boolean {
    return (
      criteria != null &&
      criteria.equipmentLibraryId != null &&
      criteria.equipmentLibraryId !== CONFIG.constants.noneDropdownValue &&
      criteria.equipmentClassId != null &&
      criteria.equipmentClassId !== CONFIG.constants.noneDropdownValue
    );
  }

  constructor() {}
}
